import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CoreApiModule, Configuration } from '@tribuu-api';
import { environment } from '@env';

@NgModule({
  imports: [
    HttpClientModule,
    CoreApiModule.forRoot(() => new Configuration({ basePath: environment.apiUrl })),
  ],
  exports: [HttpClientModule],
})
export class DataModule {}
